import {
  getPaltelCustomerInfoApi,
  getFixedLineServiceInfoFromAPI,
  getFixedLineInstallmentsDetailsfromAPI
} from './../../api/fixedLineCustomerInfo/index'
import { getFixedLineWifiBandWidthFromApi, getFixedLineWifiNetworksFromApi, getReconnectionEligbleServices } from './../../api/fixedLineServices/index'
import {
  SET_PALTEL_CUSTOMER_INFO,
  FAILED_SET_PALTEL_CUSTOMER_INFO,
  GET_NOTIFICATIONS_LIST,
  SET_ACCESS_PAGE_LIST,
  SET_ACTIVE_SERVICES,
  SET_RECONNECTION_ELIGBLE_SERVICES,
  SET_INSTALLMENT_DETAILS,
} from './actionsTypes'
import {
  getNotificationFromAPI,
  getQuickAccessPagesListApi,
} from './../../api/customerInfo/index'

export const getPaltelCustomerInfo = async (dispatch) => {
  getFixedLineNotificationsList(dispatch)
  dispatch(setPaltelCustomerInfo({ isLoading: true }))
  const res = await getPaltelCustomerInfoApi()
  dispatch(setPaltelCustomerInfo({ ...res.data, loaded: true }))
  if (res.error) {
    dispatch(paltelCustomerInfoFailed(res.error))
  }
}

export const paltelCustomerInfoFailed = (error) => ({
  type: FAILED_SET_PALTEL_CUSTOMER_INFO,
  payload: error,
})
export const getFixedLineNotificationsList = async (dispatch) => {
  const res = await getNotificationFromAPI()
  dispatch(setNotificationsList(res))
}

export const getFixedQuickAccessPagesList = async (dispatch) => {
  dispatch(setAccessPageList({ isLoading: true }))
  const res = await getQuickAccessPagesListApi()
  dispatch(setAccessPageList(res))
}
export const getFixedLineServiceInfo = async (dispatch) => {
  dispatch(setActiveServiceInfo({ isLoading: true }))
  const res = await getFixedLineServiceInfoFromAPI()
  dispatch(setActiveServiceInfo(res))
}
export const getFixedLineReconnectionEligbleServices = async (dispatch) => {
  dispatch(setReconnectionEligbleServices({ isLoading: true }))
  const res = await getReconnectionEligbleServices()
  dispatch(setReconnectionEligbleServices(res))
}

export const getFixedLineInstallmentDetails = async (dispatch) => {
  dispatch(setInstallmentDetails({ isLoading: true }))
  const res = await getFixedLineInstallmentsDetailsfromAPI()
  dispatch(setInstallmentDetails(res))
}



export const setPaltelCustomerInfo = (PaltelCustomerInfo) => ({
  type: SET_PALTEL_CUSTOMER_INFO,
  payload: PaltelCustomerInfo,
})

export const setNotificationsList = (notificationsInfo) => ({
  type: GET_NOTIFICATIONS_LIST,
  payload: notificationsInfo,
})

export const setAccessPageList = (accessPageList) => ({
  type: SET_ACCESS_PAGE_LIST,
  payload: accessPageList,
})
export const setActiveServiceInfo = (activeServiceInfo) => ({
  type: SET_ACTIVE_SERVICES,
  payload: activeServiceInfo,
})
export const setReconnectionEligbleServices = (
  reconnectionEligbleServices
) => ({
  type: SET_RECONNECTION_ELIGBLE_SERVICES,
  payload: reconnectionEligbleServices,
})

export const setInstallmentDetails = (
  installments
) => ({
  type: SET_INSTALLMENT_DETAILS,
  payload: installments,
})




